export function extractDateParts(dateString) {
    
    // Convert string to Date object
    const dateObj = new Date(dateString); 
    
    // Extract parts
    const day = dateObj.getDate(); // 18
    const fullMonth = dateObj.toLocaleString('en-US', { month: 'long' }); // January
    const shortMonth = dateObj.toLocaleString('en-US', { month: 'short' }); // Jan
    const year = dateObj.getFullYear(); // 2025
    const weekday = dateObj.toLocaleString('en-US', { weekday: 'short' }).toLowerCase(); // fri

    // Return parts
    return { day, shortMonth, fullMonth, year, weekday };

}